import * as React from 'react';

export const ProgressBarCursorIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.164978 0.334961L8.50497 8.66496L16.835 0.334961H0.164978Z" fill={props.fill || '#373F4E'} />
    </svg>
  );
};
